import View from './view';
import {useSelector, useDispatch} from 'react-redux';
import {profileNotificationsByIdSelector} from '../../../redux/selectors/profile';
import {NotificationStatus} from '../../../shared/models/profile/notification';
import {readNotification} from '../../../redux/actions/profile';
import {getProfileNotification} from '../../../redux/actions/profile/index';
import {useEffect} from 'react';

export const NotificationMobile = (props: {route: {params: {id: number}}}) => {
  const id = props.route.params.id;
  const notification = useSelector(profileNotificationsByIdSelector(id));
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getProfileNotification(id));
  }, [id]);

  useEffect(() => {
    if (notification?.id && notification?.statusId === NotificationStatus.NotRead) {
      dispatch(readNotification(notification.id || id));
    }
  }, [notification?.id, notification?.statusId === NotificationStatus.NotRead]);

  const newProps = {
    notification,
  };
  return View(newProps);
};
